import { HandleErrorAndLoading } from "@common/handleErrorAndLoading/HandleErrorAndLoading";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid/Grid";
import { useEffect } from "react";
import { useGetUserContact } from "./hooks/useGetUserContact";
import UserContactNumber from "./UserContactNumber";
import { UserEmail } from "./UserEmail";
import UserIdentification from "./UserIdentification";
import { UserPassword } from "./UserPassword";

export const MyDetails = () => {
    const { getUserDetails, getUserDetailsState, userDetails } = useGetUserContact();

    useEffect(getUserDetails, []);

    return (
        <CardContent>
            <HandleErrorAndLoading
                error={getUserDetailsState.error}
                isLoading={getUserDetailsState.isLoading}
                retryFetch={getUserDetails}
            >
                <Grid container spacing={2}>
                    <UserIdentification userDetails={userDetails} getUserDetails={getUserDetails} />
                    <UserContactNumber mobileNumber={userDetails?.phoneNumber || ""} />
                    <UserEmail email={userDetails ? userDetails.email : ""} />
                    <UserPassword />
                </Grid>
            </HandleErrorAndLoading>
        </CardContent>
    );
};
